import ProductPointsModel from '@/models/Cart/product-points';

export default class ProductPointsList {
    constructor(data) {
        // init products
        this._products = [];
        // init segments
        this._segments = {};
        // set data
        this.setData(data);
    }

    get products() {
        return this._products;
    }

    get segment() {
        return this.data.hasOwnProperty('segment') ? this.data.segment : null;
    }

    get segments() {
        return this._segments;
    }

    get page() {
        return this.data.hasOwnProperty('page') ? this.data.page : null;
    }

    get totalPages(){
        return this.data.hasOwnProperty('totalPages') ? this.data.totalPages : null;
    }

    get totalProducts(){
        return this.data.hasOwnProperty('totalProducts') ? this.data.totalProducts : null;
    }

    get mub(){
        return this.data.hasOwnProperty('mub') ? this.data.mub : null;
    }

    setData(data, itemsInCart){
        // if first page, reset product list, otherwise add to current list
        if(!data.hasOwnProperty('page') || data.page == 1){
            this._products = [];
        }

        if(data.hasOwnProperty('segments') && data.segments){
            this._segments = data.segments;
            // remove segments because they are stored aside
            delete data.segments;
        }

        if(data.hasOwnProperty('products')){
            // set products
            this.addProducts(data.products, itemsInCart);
            // remove products from data
            delete data.products;
        }
        
        // set remaining data
        this.data = data;
    }

    addProducts(list, itemsInCart){
        let quantities = this._getQuantitiesInCart(itemsInCart);

        list.forEach(item => {
            const inCart = quantities.hasOwnProperty(item.groupId) ? quantities[item.groupId] : null;
            this._products.push(new ProductPointsModel(item, inCart));
        });
        // const len = list.length;
        // for(let i=0; i < len; i++){
        //     const item = list[i];
        //     const inCart = quantities.hasOwnProperty(item.groupId) ? quantities[item.groupId] : null;

        //     this._products.push(new ProductPointsModel(item, inCart));
        // }
    }

    updateItemsInCart(itemsInCart){
        let quantities = this._getQuantitiesInCart(itemsInCart);

        this._products.forEach(item => {
            item.skusInCart = quantities.hasOwnProperty(item.groupId) ? quantities[item.groupId] : null;
        });
    }

    _getQuantitiesInCart(itemsInCart){
        let quantities = {};

        if(itemsInCart && itemsInCart.length){

            itemsInCart.forEach(element => {
                if(!quantities.hasOwnProperty(element.groupId)){
                    // initialize "groupId", otherwise will trigger error 
                    // "Cannot set property 'NUT00/1593870179' of undefined"
                    quantities[element.groupId] = {};    
                }
                quantities[element.groupId][element.sku] = element.quantity;
            });
            // console.log('itemsInCart', itemsInCart);
            // console.log('quantities', quantities);
        }

        return quantities;
    }
}